import { WorkingHours } from "@/actions/types";
import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { format, isValid, parse } from "date-fns";
import { ptBR } from "date-fns/locale";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function createBrCurrency(value: number) {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(value);
}

export function sortWorkingHoursWeekDays(
  weekDays: WorkingHours[],
): WorkingHours[] {
  const weekOrder = [
    "SUNDAY",
    "MONDAY",
    "TUESDAY",
    "WEDNESDAY",
    "THURSDAY",
    "FRIDAY",
    "SATURDAY",
  ];

  if (!Array.isArray(weekDays)) {
    return [];
  }

  return weekDays.sort(
    (a, b) => weekOrder.indexOf(a.week_day) - weekOrder.indexOf(b.week_day),
  );
}

export function formatDate(date: string | Date): string {
  try {
    const dateObj = typeof date === "string" ? new Date(date) : date;

    if (!isValid(dateObj)) {
      return "Data inválida";
    }

    return format(dateObj, "dd/MM/yyyy HH:mm", {
      locale: ptBR,
    });
  } catch (error) {
    console.error("Erro ao formatar data:", error);
    return "Data inválida";
  }
}

export function formatPhone(phone: string): string {
  if (!phone) return "";
  const cleaned = phone.replace(/\D/g, "");
  if (cleaned.length === 11) {
    return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 7)}-${cleaned.slice(7, 11)}`;
  }
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 6)}-${cleaned.slice(6, 10)}`;
  }
  return phone;
}

export function formatDuration(duration: string): string {
  if (!duration) return "";
  return format(parse(duration, "HHmm", new Date()), "HH:mm");
}

export function formatCurrency(value: string): string {
  if (!value) return "";

  const numberValue = Number(value);

  if (isNaN(numberValue)) return "";

  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(numberValue);
}

export function parseCurrency(value: string): number {
  const digits = value.replace(/\D/g, "");
  return digits ? Number(digits) / 100 : 0;
}
